import { render, staticRenderFns } from "./WalletNotOpen.vue?vue&type=template&id=501444ba&scoped=true&"
import script from "./WalletNotOpen.vue?vue&type=script&lang=ts&"
export * from "./WalletNotOpen.vue?vue&type=script&lang=ts&"
import style0 from "./WalletNotOpen.vue?vue&type=style&index=0&id=501444ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501444ba",
  null
  
)

export default component.exports